import SearchBox from './SearchBox';

export * from './SearchBox';
export * from './SearchBoxWrapper';

export default SearchBox;
